import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Container
name: Container
category: React - Core
---

A `Container` component maintains the proper margins/padding for content on DBCOM.
A `Container` is mainly used as a child of the `<body>`, but can be used anywhere
content needs to be wrapped to provide standard padding between content and edges
of screen.

### Props
| Prop Name       | Description                                 |Type            | Default Value             | Required?     |
|-----------------|---------------------------------------------|----------------|---------------------------|---------------|
| isFullwidth     | Content does not have a max width.          | boolean        | false                     | no            |

```html_example
  <Container isFullwidth>
    ...
  </Container>
```
*/
const Container = (props) => {
  const classes = [
    'is-container',
    props.className ? props.className : '',
    props.isFullwidth ? 'is-fullwidth' : '',
  ]

  return (
    <div className={classes.join(' ')}>
      { props.children }
    </div>
  )
}

Container.defaultProps = {
  isFullwidth: false,
}

Container.propTypes = {
  isFullwidth: PropTypes.bool,
}

export default Container
